import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
var PromptControllerContext = /*#__PURE__*/React.createContext(null);

var PromptControllerProvider = function PromptControllerProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      modalController = _useState2[0],
      setModalController = _useState2[1];

  return /*#__PURE__*/React.createElement(PromptControllerContext.Provider, {
    value: {
      setModalController: setModalController
    }
  }, children, modalController);
};

var usePromptController = function usePromptController() {
  return useContext(PromptControllerContext);
};

export { PromptControllerProvider, usePromptController };